// eslint-disable-next-line import/prefer-default-export
export enum TABLE_LOAD_DATA_MODE {
  ALL = 'ALL',
  ACTIVE = 'ONLY_ACTIVE',
  INACTIVE = 'ONLY_INACTIVE',
}
